import type { SlateTopBlock } from '@atlas/renderer';
import editorFeatures, { editorBlockFeatures, type TEditorFeature } from '@atlas/tool/box/slate/editorFeatures';
import type { TWithRestrictionsValue } from '@atlas/tool/box/slate/withRestrictions';

export default function translateFeaturesToRestrictions(features: TEditorFeature[]) {
    return features.reduce<TWithRestrictionsValue[]>((list, feature) => {
        if (!editorBlockFeatures.includes(feature as SlateTopBlock['type'])) return list;

        list.push(feature as TWithRestrictionsValue);
        if (feature === editorFeatures.callout) list.push('icon', 'paragraph');
        if (feature === editorFeatures.numberedList) list.push('list-item');
        if (feature === editorFeatures.bulletedList) list.push('list-item');
        if (feature === editorFeatures.table) list.push('table-row', 'table-cell');
        if (feature === editorFeatures.video) list.push('video-embed');

        return list;
    }, []);
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('translateFeaturesToRestrictions', async () => {
        it.todo('🤷');
    });
}

// #endregion
